import React from 'react'
import { Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer'
import {
  CGV,
  CustomerAddress,
  DocumentDate,
  Footer,
  Header,
  Payment,
  style,
  Subject,
  TableBody,
  TableHead,
  TableTotal
} from '../../document/DocumentPDF'
import { baseDocument } from '../../../utils/constants/misc'

const InvoicePDF = ({ invoice_param: invoice, company_param: company, settings, logo_param: img }) => {
  const customer = invoice.customer
  const styles = StyleSheet.create(style)

  const References = () => {
    if (invoice) {
      return (
        <View style={[styles.rightContainer, { marginTop: 20 }]}>
          <View style={[styles.rightContainer, { marginTop: 20 }]}>
            <Text style={styles.boldWithSpace}>Référence facture</Text>
            <Text style={styles.address}>{invoice.invoice_number}</Text>
          </View>
          {invoice.quote_id !== null && (
            <View style={styles.rightContainerNoMT}>
              <Text style={styles.boldWithSpace}>Référence devis</Text>
              <Text style={styles.address}>{invoice.quote.quote_number}</Text>
            </View>
          )}
        </View>
      )
    }
  }

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View fixed>
          <Header styles={styles} title={'FACTURE'} img={img} />
          <References />
          <DocumentDate date={invoice.invoice_date} styles={styles} />
        </View>
        <View>
          <CustomerAddress styles={styles} company={company} customer={customer} />
          <Subject styles={styles} document={invoice} />
        </View>
        <View fixed>
          <TableHead styles={styles} headers={baseDocument} />
        </View>
        <View>
          <TableBody headers={baseDocument} lines={invoice.lines} styles={styles} />
          <TableTotal total={invoice.total_amount_net} styles={styles} company={company} />
          <Payment customer={customer} settings={settings} styles={styles} />
        </View>

        <Footer company={company} styles={styles} />
      </Page>
      <CGV customer={customer} company={company} styles={styles} />
    </Document>
  )
}

export default React.memo(InvoicePDF)
